import { useEffect, useRef, useState } from "react";

import Presentation from "./presentation";

const component = props => {
	const {
		description
	} = props;

	const [ showFullDescription, setShowFullDescription ] = useState ( false );
	const [ isMoreThanTwoLines, setIsMoreThanTwoLines ]   = useState ( false );
	const [ hideSeeBtn, setHideSeeBtn ]                   = useState ( false );
	const descriptionRef                                  = useRef ( null );
	const runOnceRef                                      = useRef ( false );

	// this useEffect is used to hide see btn if description is short
	useEffect ( () => {
		// run this useEffect only once
		if ( !descriptionRef.current && !runOnceRef.current )
			return;

		const isLineHeightEqualInitially =
			descriptionRef.current.children[0].scrollHeight - descriptionRef.current.children[0].clientHeight == 0;

		setHideSeeBtn ( isLineHeightEqualInitially );

		runOnceRef.current = true;

	}, [ descriptionRef, description ] );

	// this useEffect is used to show 3 dots if description is long
	useEffect ( () => {
		if ( !descriptionRef.current )
			return;

		const isMoreThanTwoLines =
			descriptionRef.current.children[0].scrollHeight > descriptionRef.current.children[0].clientHeight;

		setIsMoreThanTwoLines ( isMoreThanTwoLines );

	}, [ descriptionRef ] );

	const toggleDescription = () => {
		setShowFullDescription ( !showFullDescription );
	  };

	return (
		<Presentation
			description         = { description }
			descriptionRef      = { descriptionRef }
			hideSeeBtn          = { hideSeeBtn }
			isMoreThanTwoLines  = { isMoreThanTwoLines }
			showFullDescription = { showFullDescription }
			toggleDescription   = { toggleDescription }
		/>
	);
};

export default component;